export class EventTypeFilter {
    constructor(eventTypeFilterId: number, filterHeading: string, eventTypeIdList: number[]) {
        this.eventTypeFilterId = eventTypeFilterId;
        this.filterHeading = filterHeading;
        this.eventTypeIdList = eventTypeIdList;
    }
    eventTypeFilterId: number;
    filterHeading: string;
    eventTypeIdList: number[];
}
